// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_WebhookStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/webhook_status/{id}
 *
 * Locally composed webhook status object — fields are merged from a
 * fixed local default plus selected fields from the provider's
 * findWebhookByUrlPattern() return value (id, url, events, enabled,
 * interrupted, has_auth_token).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsFranchises_WebhookStatusResponseDados {
configured: boolean
events: unknown[]
enabled: boolean
interrupted: boolean
has_auth_token: boolean
supports_webhook_config: boolean
webhook_id?: string
webhook_url?: string
last_sync?: string
}

export type SubaccountsFranchises_WebhookStatusResponse = ApiResponse<SubaccountsFranchises_WebhookStatusResponseDados>;

registerResponseContract('SubaccountsFranchises_WebhookStatusResponse', {
  configured:              { type: 'boolean', required: true },
  events:                  { type: 'array',   required: true },
  enabled:                 { type: 'boolean', required: true },
  interrupted:             { type: 'boolean', required: true },
  has_auth_token:          { type: 'boolean', required: true },
  supports_webhook_config: { type: 'boolean', required: true },
  webhook_id:              { type: 'string',  required: false },
  webhook_url:             { type: 'string',  required: false },
  last_sync:               { type: 'string',  required: false },
})
